/**
 * Created by StoneWang on 2020/11/27.
 */
import React from 'react';
//import Reflux from 'reflux';
import {hashHistory} from 'react-router'
import {Button} from 'antd';
import {DmsTab} from 'Components';
import { detail } from '../../service/notice';
import { sKeylist } from '../../service/dictionary/dataitem';
import '../info/infodetail.css';
//import { Actions, Store} from './store';

class InfoDetail extends React.Component {
	constructor(props) {
		super(props);
    //this.store = Store;
    //this.storeKeys = ['detail'];
		this.state = {
			infoId: parseInt(this.props.params.id, 10),
      notice_type: {},
      detail: {},
			//detail: {
			//	title: '高德和百度地图，谁靠谱？',
			//	pic: 'pic-banner03.png',
			//	read: '133',
			//	comment: '133',
			//	content: 'xxxxxxxxxxxxxxxxxxxxxxxxx'
			//}
		}
	}
  componentWillMount () { //准备数据
    const self = this;
    sKeylist({ sKey: 'notice_type' }).then(res => { //类型
      if(res.status){
        let obj = {};
        res.data.forEach(x => {
          obj[x.sKey] = x.name
        })
        let timer = window.setInterval(function () {
          if (self.mounted) {
            window.clearInterval(timer);
            self.setState({ notice_type: obj })
          }
        }, 200);
      }
    })
  }
  componentDidMount() {
		const self = this;
    self.mounted = true;
    detail(this.state.infoId).then(res => {
      if(res.status){
        self.setState({
          detail: res.data,
        });
      }
    });
	}
	goView(url) {
		hashHistory.push(url);
	}
  goBack() {
    hashHistory.goBack();
  }

	openModal() {
		this.remarkModal.showModal();
	}

	render() {
		const {detail, notice_type} = this.state;

		return <div className="dms-main-box">

			<DmsTab options={[`${notice_type[detail.type+'']}`]} defaultKey={0}>
				<Button onClick={this.goBack}>返回</Button>
				{/*<Button onClick={this.goView.bind(this, `/notice/add/${infoId}`)}>编辑</Button>*/}
			</DmsTab>
			<div className="dms-table-box">
				<div className="main">
					<h1 className='detail_title'>{detail.title||''}</h1>
					<p className='comment'>发布时间：{detail.publishDate ? new Date(detail.publishDate).format('yyyy-MM-dd hh:mm') : ''}</p>
				</div>
				<div className="info_content" dangerouslySetInnerHTML={{__html: detail.content}}></div>
			</div>
		</div>
	}
}
;
export default InfoDetail;



// WEBPACK FOOTER //
// ./src/routes/carousel/detail.js